import { render } from "./DashKpiStrip.vue?vue&type=template&id=bb69f4b0&scoped=true&ts=true"
import script from "./DashKpiStrip.vue?vue&type=script&lang=ts"
export * from "./DashKpiStrip.vue?vue&type=script&lang=ts"

import "./DashKpiStrip.vue?vue&type=style&index=0&id=bb69f4b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb69f4b0"]])

export default __exports__